import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const ruTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Имя (строчные буквы, без специальных символов)',
    add: 'Добавить',
    allowedFileTypes: 'Разрешенные типы файлов',
    allowedFileTypesDescription:
      'Ограничьте разрешенные типы файлов (например, изображение/*, приложение/pdf). Оставьте пустым, чтобы разрешить все типы.',
    allowMultipleFiles: 'Разрешить несколько файлов',
    amountInCents: 'Сумма в центах',
    basePrice: 'Базовая цена',
    bcc: 'BCC',
    brand: 'Бренд',
    cc: 'СС',
    checkboxPlural: 'Поля флажков',
    checkboxSingular: 'Флажок',
    checkedByDefault: 'Проверено по умолчанию',
    chooseConfirmationType:
      'Выберите, следует ли отображать сообщение на странице или перенаправлять на другую страницу после отправки формы.',
    condition: 'Состояние',
    confirmationMessage: 'Подтверждающее сообщение',
    confirmationType: 'Тип подтверждения',
    countryPlural: 'Деревенские поля',
    countrySingular: 'Страна',
    creditCard: 'Кредитная карта',
    customURL: 'Пользовательский URL-адрес',
    datePlural: 'Поля даты',
    dateSingular: 'Дата',
    defaultValue: 'Значение по умолчанию',
    divide: 'Разделить',
    documentToLinkTo: 'Документ для ссылки',
    doesNotEqual: 'Не равно',
    emailFrom: 'Электронная почта от',
    emailPlural: 'Поля электронной почты',
    emailsDescription:
      'Отправляйте персонализированные электронные письма после отправки формы. Используйте списки, разделенные запятыми, чтобы отправить одно и то же электронное письмо нескольким получателям. Чтобы сослаться на значение из этой формы, заключите имя этого поля в двойные фигурные скобки, т. е. {{firstName}}. Вы можете использовать подстановочный знак {{*}} для вывода всех данных и {{*:table}} для их форматирования в виде таблицы HTML в электронном письме.',
    emailSingular: 'электронная почта',
    emailTo: 'Отправить по электронной почте',
    equals: 'Равно',
    field: 'Поле',
    fields: 'Поля',
    fieldWidth: 'Ширина поля (в процентах)',
    hasAnyValue: 'Имеет любое значение',
    internalLink: 'Внутренняя ссылка',
    label: 'Этикетка',
    maxFileSize: 'Максимальный размер файла (байты)',
    maxFileSizeDescription:
      'Максимальный размер файла в байтах. Оставьте пустым, чтобы не было ограничений.',
    message: 'Сообщение',
    messageDescription:
      'Введите сообщение, которое должно быть отправлено в этом электронном письме.',
    messagePlural: 'Блоки сообщений',
    messageSingular: 'Сообщение',
    mimeType: 'MIME-тип',
    mimeTypePlural: 'MIME-типы',
    mimeTypeSingular: 'MIME-тип',
    multiply: 'Умножить',
    numberPlural: 'Числовые поля',
    numberSingular: 'Номер',
    optionPlural: 'Опции',
    optionSingular: 'Вариант',
    paymentFieldPlural: 'Поля оплаты',
    paymentFieldSingular: 'Оплата',
    paymentProcessor: 'Платежный процессор',
    paymentStatus: 'Статус',
    placeholder: 'Заполнитель',
    priceConditions: 'Ценовые условия',
    priceConditionsPlural: 'Ценовые условия',
    priceConditionsSingular: 'Цена Состояние',
    radioOptions: 'Опции атрибутов радио',
    radioPlural: 'Радиополя',
    radioSingular: 'Радио',
    redirect: 'Перенаправление',
    replyTo: 'Ответить',
    required: 'Требуется',
    selectOptions: 'Выберите параметры',
    selectPlural: 'Выберите поля',
    selectSingular: 'Выбрать',
    statePlural: 'Государственные поля',
    stateSingular: 'Государство',
    staticValue: 'Статическое значение',
    subject: 'Тема',
    submitButton: 'Отправить метку кнопки',
    subtract: 'Вычесть',
    textareaPlural: 'Текстовые поля',
    textareaSingular: 'Текстовая область',
    textPlural: 'Текстовые поля',
    textSingular: 'Текст',
    title: 'Название',
    token: 'жетон',
    uploadCollection: 'Загрузить коллекцию',
    uploadCollectionDescription: 'Выберите, в какой коллекции загрузки хранить файлы',
    uploadFieldPlural: 'Загрузить поля',
    uploadFieldSingular: 'Загрузить',
    urlToRedirectTo: 'URL-адрес для перенаправления',
    value: 'Значение',
    valueOfField: 'Значение поля',
    valueType: 'Тип значения',
  },
}

export const ru: PluginLanguage = {
  dateFNSKey: 'ru',
  translations: ruTranslations,
}
